import api from '@/api/index'
import config from '@/config/index'
import utils from '@/utils'
import {GETORGDEPTS_SUCCESS, DEPT_UPDATE, GETORGDEPTSEMPT_SUCCESS, GETMENUS_WIDTH_SUCCESS} from "../types";

const state = {
  menus: [], // 组织架构
  dept: {}, // 当前部门
  list: [], // 当前列表(部门下面的人员)
  dimension: {
    menusWidth: '',
    menusDepth: ''
  }
}

const actions = {
  addDept (store, dept) {
    api.post(config.bylApiPath, '/dep/edit', dept, function (r) { // 提交正常
      store.dispatch('getDepts') // 重新获取
    })
  },
  delDept (store, deptId) { // 删除部门
    api.get(config.bylApiPath, '/dep/delete/' + deptId, null, function (r) { // 提交正常
      store.dispatch('getDepts') // 重新获取
    })
  },
  getDepts (store, dept) { // 获取所有部门
    var that = this
    var max = 0;
    var depth = 0;
    return new Promise(function (resolve, reject) {
      api.post(config.bylApiPath, '/dep/list', null, function (r) { // 获取正常
        function iteration (data, level) {
          var _getMaxWidth = function (str) {
            return utils.getCurrentStrWidth(str, '12px')
          };
          level++
          depth = level
          for (var j = 0; j < data.length; j++) {
            let maxWidth = _getMaxWidth(data[j].name, '12px')
            if (max < maxWidth) {
              max = maxWidth
            }
            data[j].level = level
            if (data[j].level == '1') {
              data[j].opened = true
            } else {
              data[j].opened = false
            }
            if (data[j].children != undefined && data[j].children.length > 0) {
              iteration(data[j].children, level)
            }
          }
        }
        if (r.data) {
          iteration(r.data, 0) // 递归添加属性'opened'
          store.commit(GETORGDEPTS_SUCCESS, r.data) // 更新state
          if (dept) {
            store.commit(DEPT_UPDATE, dept)
          } else {
            store.commit(DEPT_UPDATE, r.data[0]) // 默认取第一个部门
          }
          store.commit(GETMENUS_WIDTH_SUCCESS, {max: max, depth: depth})
          // store.dispatch('getPersonByDept', {id: r.data[0].id, pageNo: 1, pageSize: 12}) // 默认取第一个部门下面的所有人员
          resolve(r.data)
        } else { // 空的情况
          store.commit(GETORGDEPTS_SUCCESS, []) // 更新state
          store.commit(DEPT_UPDATE, {}) // 默认取第一个部门
          resolve(undefined)
        }
      })
    })
  },
  setDept (store, dept) {
    store.commit(DEPT_UPDATE, dept)
    // store.dispatch('getPersonByDept', dept.id)
  },
  getPersonByDept (store, params) { // 没加缓存的接口
    var that = this
    return new Promise(function (resolve, reject) {
      api.post(config.bylApiPath, '/member/members/byDep', params, function (r) {
        var d;
        if (!r.data) { d = [] } else { d = r.data }
        store.commit(GETORGDEPTSEMPT_SUCCESS, d)
        resolve(r)
      })
    })
  },
  getPeopleByDept (store, params) { // 加缓存的接口
    var that = this
    return new Promise(function (resolve, reject) {
      api.post(config.bylApiPath, '/dep/searchDepMember', params, function (r) {
        var d;
        if (!r.data) { d = [] } else { d = r.data }
        store.commit(GETORGDEPTSEMPT_SUCCESS, d)
        resolve(r)
      })
    })
  },
  addPerson (store, person) {
    api.post(config.bylApiPath, '/member/edit', person, function (r) { // 提交正常
    })
  },
  getGroups (store) { // 获取所有小组
    api.post(config.bylApiPath, '/group/groups', null, function (r) { // 获取正常
      function iteration (data) {
        for (var j = 0; j < data.length; j++) {
          data[j].level = '1'
          data[j].opened = false
          if (data[j].children != undefined && data[j].children.length > 0) {
            iteration(data[j].children)
          }
        }
      }
      if (r.data) {
        iteration(r.data) // 递归添加属性'opened'
        store.commit(GETORGDEPTS_SUCCESS, r.data) // 更新state
        store.commit(DEPT_UPDATE, r.data[0]) // 默认取第一个部门/小组
      }
    })
  },
  clearPeople (store) {
    store.commit(GETORGDEPTSEMPT_SUCCESS, [])
  }
}
const mutations = {
  [GETORGDEPTS_SUCCESS] (state, action) {
    state.menus = action
  },
  [DEPT_UPDATE] (state, action) {
    state.dept = action
  },
  [GETORGDEPTSEMPT_SUCCESS] (state, action) {
    state.list = action
  },
  [GETMENUS_WIDTH_SUCCESS] (state, action) {
    state.dimension = {
      menusWidth: action.max,
      depth: action.depth
    }
  }
}

const getters = {
  getCurrentList: state => {
    if (state.list) {
      return state.list
    } else {
      return []
    }
  },
  getCurrentDepts: state => {
    if (state.menus) {
      return state.menus
    } else {
      return []
    }
  },
  getCurrentDept: state => {
    if (state.dept) {
      return state.dept
    } else {
      return []
    }
  },
  getDimension: state => {
    if (state.dimension) {
      return state.dimension
    } else {
      return ''
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/orgstructure.js